import { createFileRoute } from "@tanstack/react-router";
import { LivePage } from "src/pages/live/LivePage";

export const Route = createFileRoute("/")({
	component: LivePage,
});
